import React, { useEffect, useRef, useImperativeHandle, useState } from "react";
import { dateToString, isLaterValid, isNotEmpty, isNotUndefined, stringToDate } from "../../util/util";
import { observer } from "mobx-react";
import errMsgService from "../../services/common/errMsgService";
import stateStore from "../../store/stateStore";
const DatetimePicker = observer(React.forwardRef((props, ref) => {

    const mode = {
        DAY: 'DAY',
        MONTH: 'MONTH',
        YEAR: 'YEAR'
    };
    let maxYear = '9999';
    let minYear = '0001';
    let showButtonBar = true;
    let firstDayOfWeek = 0;
    let loopYear = 20;
    const dayNames = ['日', '月', '火', '水', '木', '金', '土'];
    const collectionMonth = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12]];
    let formatString = 'yyyy/MM/dd';
    const [isOpenContainer, setIsOpenContainer] = useState(false);
    const [datepickerMode, setDatepickerMode] = useState('');
    const [collection, setCollection] = useState([]);
    const [yearHeader, setYearHeader] = useState('');
    const [collectionYear, setCollectionYear] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const dropdownMenu = useRef(null);
    if (props.formatString) formatString = props.formatString;
    useEffect(() => {
        document.body.addEventListener('mousedown', onClickDocument);
        document.body.addEventListener('wheel', () => {
            setIsOpenContainer(false);
        });
    }, []);

    // DatetimePickerの表示位置を調整する
    useEffect(() => {
        // DatetimePickerが表示されている場合、DatetimePickerの表示位置を再設定する
        if (isOpenContainer) {
            setPositionMenu();
        }
    }, [isOpenContainer]);

    useImperativeHandle(ref, () => ({
        checkDate: checkDate.bind(this),
    }));

    // DatetimePickerのレンダー
    const toogleDatePicker = () => {
        let datepickerMode = mode.DAY;
        // DatetimePickerが月別表示となっている場合
        if (props.formatString === 'YYYY/MM') {
            datepickerMode = mode.MONTH;
        }
        setDatepickerMode(datepickerMode);
        setSelectedMonth(setDate(getDateFormat()));
        // DatetimePickerが日別表示となっている場合
        if (!isOpenContainer && datepickerMode === mode.DAY) {
            addCollection();
        }
        setIsOpenContainer(!isOpenContainer);
    }

    // datetimepickerの日付を選択する
    const setSelectedDate = (event) => {
        event.preventDefault();
        const { rowIndex, colIndex } = getIndex(event.currentTarget.value);
        const date = +(collection[rowIndex][colIndex]);
        let selectedDate = null;
        // 選択した日付が当月の日付の場合
        if (date > 0) {
            selectedDate = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), date);
            setSelectedMonth(selectedDate);
        } else {
            // 選択した日付が当月の日付でない場合
            const updateMonth = mathAbs(date) > 15 ? -1 : 1;
            selectedDate = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + updateMonth, mathAbs(date));
        }
        setTimeout(() => {
            checkDate(selectedDate);
            onChangeText(selectedDate);
            onCloseCalendar();
        }, 0);
    }

    // 表示する月を選択する
    const setSelectMonth = (event) => {
        const date = new Date(selectedMonth.getFullYear(), +(event.currentTarget.id) - 1, 1);
        setTimeout(() => {
            // テキストボックスに'YYYY/MM'を表示する場合
            if (props.formatString === 'YYYY/MM') {
                onChangeText(date);
                onCloseCalendar();
            } else {
                setSelectedMonth(date);
                setDatepickerMode(mode.DAY);
            }
        }, 0);

    }

    // 表示年を選択する
    const setSelectYear = (event) => {
        const date = new Date(+(event.currentTarget.id), 0, 1);
        setTimeout(() => {
            setSelectedMonth(date);
            setDatepickerMode(mode.MONTH);
        }, 0);
    }

    // 前月を選択する
    const onClickPreMonth = () => {
        // 現在の年が'0001'且つ当月が'1'の場合、終了する
        if (String(selectedMonth.getFullYear()) === minYear && selectedMonth.getMonth() === 0) {
            return;
        }
        let selectedMonthNew = selectedMonth;
        selectedMonthNew.setMonth(selectedMonth.getMonth() - 1);
        setSelectedMonth(selectedMonthNew);
        addCollection(selectedMonth);
    }

    // 翌月を選択する
    const onClickNextMonth = () => {
        // 現在の年が'9999'の場合、終了する
        if (String(selectedMonth.getFullYear()) === maxYear) {
            return;
        }
        let selectedMonthNew = selectedMonth;
        selectedMonthNew.setMonth(selectedMonth.getMonth() + 1);
        setSelectedMonth(selectedMonthNew);
        addCollection(selectedMonth);

    }

    // 翌年を選択する
    const onClickNextYear = () => {
        let selectedMonthNew = new Date(selectedMonth.getFullYear() + 1, selectedMonth.getMonth(), 1);
        setSelectedMonth(selectedMonthNew);
    }

    // 前年を選択する
    const onClickPreYear = () => {
        let selectedMonthNew = new Date(selectedMonth.getFullYear() - 1, selectedMonth.getMonth(), 1);
        setSelectedMonth(selectedMonthNew);
    }

    // 未来の年を選択する
    const onClickNextLoopYear = () => {
        const endYear = +(yearHeader.split('-')[1]);
        addCollectionYear(endYear + 1);
    }

    // 過去の年を選択する
    const onClickPreLoopYear = () => {
        const startYear = +(yearHeader.split('-')[0]);
        addCollectionYear(startYear - loopYear);
    }

    // datetimePickerの表示形式を変更する
    const toggleMode = (event) => {
        const targer = event.currentTarget.id;
        switch (targer) {
            case mode.DAY:
                setDatepickerMode(mode.MONTH);
                break;
            case mode.MONTH:
                addCollectionYear();
                setDatepickerMode(mode.YEAR);
                break;
            default:
                break;
        }
    }

    // 当日の日付を選択する
    const onSelectToday = () => {
        setTimeout(() => {
            onChangeText(new Date);
            onCloseCalendar();
        }, 0);
    }

    // 表示中の日付を削除する
    const onClearSelect = () => {
        onChangeText(null);
        onCloseCalendar();
    }

    // datetimepickerを閉じる
    const onCloseCalendar = () => {
        setIsOpenContainer(false);
        focusText();
    }

    // ブラウザでのクリックイベント
    const onClickDocument = (event) => {
        let flag = false;
        Object.values(event.composedPath()).forEach(item => {
            // datetimepickerボタン/datetimepickerプルダウンにクリックしている場合、trueを返す
            if (item.classList) {
                if ([`uib-datepicker-${props.name}`, `ymd-btn-${props.name}`].some(c => [...item.classList].includes(c))) {
                    flag = true;
                    return;
                }
            }
        })
        // datetimepickerボタン/datetimepickerプルダウンにクリックしていない場合、datetimepickerプルダウンを閉じる
        if (!flag && document.body.querySelector('.uib-datepicker-popup')) {
            setIsOpenContainer(false);
        }
    }

    // 月内の日のリストを作成する
    const addCollection = (date = null) => {
        let selectedMonth = null;
        // 日付を選択している場合
        if (date) {
            selectedMonth = date;
        } else {
            // 日付を選択していない場合
            selectedMonth = setDate(getDateFormat());
        }
        const collection = [
            ['', '', '', '', '', '', ''],
            ['', '', '', '', '', '', ''],
            ['', '', '', '', '', '', ''],
            ['', '', '', '', '', '', ''],
            ['', '', '', '', '', '', ''],
            ['', '', '', '', '', '', ''],
            ['', '', '', '', '', '', ''],
        ];
        const startDate = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1);
        const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
        let dayIndex = firstDayOfWeek < 0 || firstDayOfWeek > 6 ? 0 : firstDayOfWeek;
        for (let index = 0; index < 7; index++) {
            collection[0][index] = dayIndex;
            if (dayIndex === 6) {
                dayIndex = 0;
            } else {
                dayIndex += 1;
            }
        }
        let currentDateNumber = 0;
        for (let rowIndex = 1; rowIndex < 7; rowIndex++) {
            for (let colIndex = 0; colIndex < 7; colIndex++) {
                if (currentDateNumber > 0 && currentDateNumber < endDate.getDate()) {
                    collection[rowIndex][colIndex] = ++currentDateNumber;
                } else if (currentDateNumber === 0 && startDate.getDay() === collection[0][colIndex]) {
                    collection[rowIndex][colIndex] = ++currentDateNumber;
                } else if (currentDateNumber === endDate.getDate()) {
                    break;
                }
            }
        }

        currentDateNumber = new Date(startDate.getFullYear(), startDate.getMonth(), 0).getDate();
        for (let colIndex = 6; colIndex >= 0; colIndex--) {
            if (collection[1][colIndex] === '') {
                collection[1][colIndex] = -currentDateNumber--;
            }
        }

        currentDateNumber = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1).getDate();
        for (let rowIndex = 5; rowIndex < 7; rowIndex++) {
            for (let colIndex = 0; colIndex < 7; colIndex++) {
                if (collection[rowIndex][colIndex] === '') {
                    collection[rowIndex][colIndex] = -currentDateNumber++;
                }
            }
        }
        setCollection(collection);
    }

    // 年のリストを作成する
    const addCollectionYear = (year) => {
        let selectedMonth = setDate(getDateFormat());
        const collectionYear = [
            ['', '', '', '', ''],
            ['', '', '', '', ''],
            ['', '', '', '', ''],
            ['', '', '', '', ''],
        ];
        let startYear = 1;
        const selectYear = selectedMonth.getFullYear();
        let endYear = loopYear;
        // 表示する年を選択している場合
        if (year) {
            startYear = year;
            endYear = year + loopYear - 1;
        } else {
            for (let i = 1; i <= +(maxYear); i++) {
                if (startYear <= selectYear && startYear + loopYear > selectYear) {
                    endYear = startYear + loopYear - 1;
                    break;
                }
                startYear += loopYear;
            }
        }
        let currentDateNumber = startYear - 1;
        for (let rowIndex = 0; rowIndex < 4; rowIndex++) {
            for (let colIndex = 0; colIndex < 5; colIndex++) {
                if (currentDateNumber > 0 && currentDateNumber < endYear) {
                    collectionYear[rowIndex][colIndex] = ++currentDateNumber;
                } else if (currentDateNumber === 0 && startYear === collection[0][colIndex]) {
                    collectionYear[rowIndex][colIndex] = ++currentDateNumber;
                } else if (currentDateNumber === endYear) {
                    break;
                }
            }
        }
        setYearHeader(`${startYear}-${endYear}`);
        setCollectionYear(collectionYear);
    }

    const setDate = (value) => {
        let selectedMonth = isNotEmpty(value) ? stringToDate(value, formatString) : undefined;
        if (!selectedMonth || String(selectedMonth.getFullYear()) < minYear || String(selectedMonth.getFullYear()) > maxYear) {
            selectedMonth = new Date();
        }
        return selectedMonth;
    }

    // 現在日付のチェック
    const checkToday = (rowIndex, colIndex, selectDay) => {
        let date = +(collection[rowIndex][colIndex]);
        let selectDate = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), selectedMonth.getDate());

        if (!date) return false;
        let today = new Date();
        if (selectDay) {
            today = selectDay;
        }
        if (date < 0) {
            date = mathAbs(date);
            const updateDate = mathAbs(date) > 15 ? -1 : 1;
            selectDate.setMonth(selectedMonth.getMonth() + updateDate);
            return checkDay(date, selectDate, today);
        }
        return checkDay(date, selectDate, today);
    }

    const checkDay = (day, selectDay, originDay) => {
        return (day &&
            originDay?.getMonth() === selectDay?.getMonth() &&
            originDay?.getFullYear() === selectDay?.getFullYear() &&
            originDay?.getDate() === day
        );
    }

    // 現在月のチェック
    const checkMonthNow = (rowIndex, colIndex, selectMonth) => {
        const month = +(collectionMonth[rowIndex][colIndex]);
        if (!month) return false;
        let monthNow = new Date();
        if (selectMonth) {
            monthNow = selectMonth;
        }
        return (month &&
            monthNow?.getMonth() + 1 === month &&
            monthNow?.getFullYear() === selectedMonth?.getFullYear()
        );
    }

    // 現在年のチェック
    const checkYearNow = (rowIndex, colIndex, selectYear) => {
        const year = +(collectionYear[rowIndex][colIndex]);
        if (!year) return false;
        let yearNow = new Date();
        if (selectYear) {
            yearNow = selectYear;
        }
        return (year && yearNow?.getFullYear() === year);
    }

    // 選択した日のチェック
    const checkSelectDay = (rowIndex, colIndex) => {

        const value = props.input ? props.input.value : '';
        let date = +(collection[rowIndex][colIndex]);

        if (value) {
            return checkToday(rowIndex, colIndex, stringToDate(value, formatString));
        } else {
            if (date < 0) return false;
            return checkToday(rowIndex, colIndex, null);
        }
    }

    // 選択した月のチェック
    const checkSelectMonth = (rowIndex, colIndex) => {
        const date = getDateFormat() ? stringToDate(getDateFormat(), formatString) : selectedMonth;
        return checkMonthNow(rowIndex, colIndex, selectedMonth);
    }

    // 選択した年のチェック
    const checkSelectYear = (rowIndex, colIndex) => {
        return checkYearNow(rowIndex, colIndex, selectedMonth);
    }

    // 負数を正数に変換する
    const mathAbs = (value) => {
        if (isNotUndefined(value)) {
            return +(value) < 0 ? - +(value) : +(value);
        }
        return '';
    }

    // テキストボックスに表示する日付を変更する
    const onChangeText = (value) => {
        if (!props.dataGrid) stateStore.setState(props.name, dateToString(value, formatString));
        if (!props.handleInputChange) return;
        const event = {
            target: {
                name: props.name,
                value: dateToString(value, formatString)
            }
        }
        props.handleInputChange(event);
    }


    const checkDate = (inputDate) => {
        // check for case: is-check-past-day
        if (isNotUndefined(props.isCheckPastDay)) {
            // get date now in millisecond from server
            const nowStr = dateToString(new Date(), "YYYY/MM/DD");
            const inputStr = dateToString(new Date(inputDate), "YYYY/MM/DD");

            if (isLaterValid(nowStr, inputStr)) {
                // エラー表示
                errMsgService.addMsgLabel("ECMN0690", props);
                // エラーコールバック関数が設定されている場合実施する
                return;
            }
        }

        // check for case: is-check-past-monday
        if (isNotUndefined(props.isCheckPastMonday)) {
            // get date now in millisecond from server
            const nowStr = dateToString(new Date(), "YYYY/MM/DD");
            const inputStr = dateToString(new Date(inputDate), "YYYY/MM/DD");
            let today = new Date();
            today.setDate(today.getDate() - today.getDay() + (today.getDay() == 0 ? -6 : 1));
            const firstWeekStr = dateToString(new Date(today), "YYYY/MM/DD");
            if (new Date(firstWeekStr).getTime() !== inputDate.getTime() && isLaterValid(nowStr, inputStr)) {
                // エラー表示
                errMsgService.addMsgLabel("ECMN1450", props);
                // エラーコールバック関数が設定されている場合実施する
                return;
            }
        }
        errMsgService.delMsgLabel(props);
    }

    // テキストボックスにフォーカスインする
    const focusText = () => {
        if (!props.input) return;
        setTimeout(() => {
            props.input.focus();
            props.input.select();
        }, 0);
    }

    // プルダウンの表示位置を動的に設定する
    const setPositionMenu = () => {

        if (!props.input) return;
        const widthDailog = document.body.offsetWidth <= 428 ? 300 : 200;
        const textBound = props.input.getBoundingClientRect();
        const screenWidth = document.body.offsetWidth;
        const textboxLeft = textBound.left + (textBound.width + 24) + widthDailog;
        const dateTimeGrid = document.body.querySelector('.date-field-grid');
        if (dateTimeGrid) {
            dateTimeGrid.style.left = `${textBound.left}px`;
            dateTimeGrid.style.top = `${textBound.top + 24}px`;
            return;
        }
        if (textboxLeft >= screenWidth) {
            dropdownMenu.current.style.left = `${-textBound.width}px`;
            dropdownMenu.current.style.right = '-22px';
        }
    }

    // 位置情報を取得する
    const getIndex = (value) => {
        const indexs = value.split('_');
        return { rowIndex: indexs[0], colIndex: indexs[1] };
    }

    const getDateFormat = () => {
        if (!props.input) return '';
        let text = props.input.value;
        if (props.formatString.length === 7 && isNotEmpty(text)) {
            text += "/01";
        }
        return text;
    }

    let renderDayBox = "";
    if (collection.length || datepickerMode == mode.DAY) {
        renderDayBox = (<tbody> {
            [1, 2, 3, 4, 5, 6].map(rowIndex => (
                (typeof rowIndex === 'number') &&
                <tr key={rowIndex}>
                    {
                        [0, 1, 2, 3, 4, 5, 6].map(colIndex => (
                            <td key={colIndex}>
                                <button value={`${rowIndex}_${colIndex}`} className={'btn btn-default btn-sm ' + (checkSelectDay(rowIndex, colIndex) && ' active')}
                                    onClick={setSelectedDate}>
                                    <span className={(+(collection[rowIndex][colIndex]) < 0 && 'text-muted ') + ((checkToday(rowIndex, colIndex) || checkSelectDay(rowIndex, colIndex)) && ' text-info')}>{mathAbs(collection[rowIndex][colIndex])}</span>
                                </button>
                            </td>
                        ))
                    }
                </tr>
            ))
        }
        </tbody>);
    };

    let renderMonthBox = "";
    if (datepickerMode == mode.MONTH) {
        renderMonthBox = (<tbody>
            {
                [0, 1, 2, 3].map(rowIndex => (
                    (typeof rowIndex === 'number') &&
                    <tr key={rowIndex}>
                        {
                            [0, 1, 2].map(colIndex => (
                                <td key={colIndex}>
                                    <button value={`${rowIndex}_${colIndex}`} className={'btn btn-default btn-sm ' + (checkSelectMonth(rowIndex, colIndex) && ' active')}
                                        id={collectionMonth[rowIndex][colIndex]} onClick={setSelectMonth}>
                                        <span className={(+(collectionMonth[rowIndex][colIndex]) < 0 && 'text-muted ')
                                            + ((checkMonthNow(rowIndex, colIndex) || checkSelectMonth(rowIndex, colIndex)) && ' text-info')}
                                        >{collectionMonth[rowIndex][colIndex]}月</span>
                                    </button>
                                </td>
                            ))
                        }
                    </tr>
                ))
            }
        </tbody>)
    }

    let renderYearBox = "";
    if (datepickerMode == mode.YEAR) {
        renderYearBox = (<tbody> {
            [0, 1, 2, 3].map(rowIndex => (
                (typeof rowIndex === 'number') &&
                <tr key={rowIndex}>
                    {
                        [0, 1, 2, 3, 4].map(colIndex => (
                            <td key={colIndex}>
                                <button value={`${rowIndex}_${colIndex}`} className={'btn btn-default btn-sm ' + (checkSelectYear(rowIndex, colIndex) && ' active')}
                                    id={collectionYear[rowIndex][colIndex]} onClick={setSelectYear}>
                                    <span className={(+(collectionYear[rowIndex][colIndex]) < 0 && 'text-muted ')
                                        + ((checkYearNow(rowIndex, colIndex) || checkSelectYear(rowIndex, colIndex)) && ' text-info')}>{collectionYear[rowIndex][colIndex]}</span>
                                </button>
                            </td>
                        ))
                    }
                </tr>
            ))
        }
        </tbody>);
    };
    return (<span className="input-group-btn">
        <button type="button" disabled={props.disabled ? 'disabled' : ''} className={"btn btn-default ymd-btn form-control " + 'ymd-btn-' + props.name} onClick={toogleDatePicker}><i className={"glyphicon glyphicon-calendar " + 'ymd-btn-' + props.name}></i></button>
        {isOpenContainer && < div className={`date-field-container ${props.dataGrid ? props.className : ''}`}>
            <ul className={'uib-datepicker-popup dropdown-menu ' + 'uib-datepicker-' + props.name} ref={dropdownMenu}>
                <li>
                    <div className='uib-datepicker'>
                        {datepickerMode === mode.DAY && <div className='uib-daypicker'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <button type="button" onClick={onClickPreMonth} className="btn btn-default btn-sm pull-left uib-left" tabIndex={-1}>
                                                <i className="glyphicon glyphicon-chevron-left"></i>
                                                <span className="sr-only">previous</span></button>
                                        </th>
                                        <th colSpan="5">
                                            <button id={mode.DAY} onClick={toggleMode} className="btn btn-default btn-sm uib-title" tabIndex={-1}>
                                                <strong >{selectedMonth.getFullYear()}年 {selectedMonth.getMonth() + 1}月</strong>
                                            </button>
                                        </th>
                                        <th>
                                            <button onClick={onClickNextMonth} className="btn btn-default btn-sm pull-right uib-right" tabIndex={-1}>
                                                <i className="glyphicon glyphicon-chevron-right"></i>
                                                <span className="sr-only">next</span>
                                            </button>
                                        </th>
                                    </tr>
                                    <tr>
                                        {
                                            [0, 1, 2, 3, 4, 5, 6].map(colIndex => (
                                                <th className='text-center'>
                                                    <small key={colIndex}>{dayNames[(collection[0][colIndex])]}</small>
                                                </th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                {renderDayBox}
                            </table>
                        </div>}
                        {datepickerMode === mode.MONTH && <div className='uib-monthpicker'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <button type="button" onClick={onClickPreYear} className="btn btn-default btn-sm pull-left uib-left" tabIndex={-1}>
                                                <i className="glyphicon glyphicon-chevron-left"></i>
                                                <span className="sr-only">previous</span></button>
                                        </th>
                                        <th>
                                            <button id={mode.MONTH} onClick={toggleMode} className="btn btn-default btn-sm uib-title" tabIndex={-1}>
                                                <strong >{selectedMonth.getFullYear()}</strong>
                                            </button>
                                        </th>
                                        <th>
                                            <button onClick={onClickNextYear} className="btn btn-default btn-sm pull-right uib-right" tabIndex={-1}>
                                                <i className="glyphicon glyphicon-chevron-right"></i>
                                                <span className="sr-only">next</span>
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                {renderMonthBox}
                            </table>
                        </div>}
                        {datepickerMode === mode.YEAR && <div className='uib-yearpicker'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <button type="button" onClick={onClickPreLoopYear} className="btn btn-default btn-sm pull-left uib-left" tabIndex={-1}>
                                                <i className="glyphicon glyphicon-chevron-left"></i>
                                                <span className="sr-only">previous</span></button>
                                        </th>
                                        <th colSpan="3">
                                            <button id={mode.YEAR} className="btn btn-default btn-sm uib-title" disabled="disabled" tabIndex={-1}>
                                                <strong >{yearHeader}</strong>
                                            </button>
                                        </th>
                                        <th>
                                            <button onClick={onClickNextLoopYear} className="btn btn-default btn-sm pull-right uib-right" tabIndex={-1}>
                                                <i className="glyphicon glyphicon-chevron-right"></i>
                                                <span className="sr-only">next</span>
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                {renderYearBox}
                            </table>
                        </div>}
                    </div>
                </li>
                {showButtonBar && <li className='uib-button-bar'>
                    <span className='btn-group pull-left'>
                        <button className='btn btn-sm btn-info uib-datepicker-current' onClick={onSelectToday}>本日</button>
                        <button className='btn btn-sm btn-danger uib-clear' onClick={onClearSelect}>消去</button>
                    </span>
                    <button className='btn btn-sm btn-success pull-right uib-close' onClick={onCloseCalendar}>閉じる</button>
                </li>}
            </ul>
        </div>}
    </span>)
}))
export default DatetimePicker;